import { mapState } from 'vuex';
import _ from 'lodash';
import { loginToken } from '~/utils/auth';
import Loading from '~/components/loading/Loading.vue';
import { LOGIN_TYPES } from '~/utils/constants';

export default {
  components: {
    loading: Loading,
  },
  data() {
    return {
      error: null,
      loading: true,
    };
  },
  computed: {
    ...mapState('router', {
      token: state => _.get(state, 'query.token', null),
    }),
  },
  mounted() {
    loginToken(this.token)
      .then(() => {
        this.loading = false;
        this.$emit('login-success', LOGIN_TYPES.EMAIL);
      })
      .catch(err => {
        this.loading = false;
        this.error = err;
      });
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/login/token/Token.js